<template>
<div class="sapp">
 <router-view></router-view>
</div>
 
</template>

<script type="text/javascript">
  export default {
    
    data(){
      return {
        active:"myTask",
  //      roleType:0,
      }
    },
    name: 'RouteContent',
    created(){
    },
    methods:{
    }


  }
</script>
<style scoped>
/* .sapp{
  margin-top: 46px;
} */
</style>